import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useToggle } from "@sportal/cdk";

import { MobileMenu } from "../../../../components/layout/headerComponents/MobileMenu/MobileMenu";
import { NavigationMenu } from "../../HelpNavigation/NavigationMenu/NavigationMenu";

export const MobileNavigationMenu = () => {
  const [opened, setOpened] = useToggle(false);
  const { section } = useParams();

  useEffect(() => {
    setOpened(false);
  }, [section, setOpened]);

  return (
    <MobileMenu toggleState={opened} toggleFn={setOpened}>
      <div className="help-header-navigation">
        <NavigationMenu />
      </div>
    </MobileMenu>
  );
};
